<style lang="stylus">
        .worksArea-container
            position relative
            width calc(100% - 291px)
            margin-left 24px
            // min-height 694px
            .worksArea-topbar
                position relative
                width 100%
                padding 16px 0 16px 16px
                background #FFFFFF
                box-shadow 0px 0px 2px rgba(27, 64, 81, 0.2)
                border-radius 5px
                z-index 2
                transition top 0.2s linear
                .topbar
                    min-height 32px
                .menubox-menu
                    li
                        height 32px
                        font-size 12px
                        color #222
                        width 85px
                        border-radius 50px
                        background #F9F9F9
                        &:not(:last-child)
                            margin-right 40px
                        &:not(:last-child)
                            margin-right 16px
                        // &.active:not(:last-child)
                        //     margin-right 24px
                        &.active
                            background var(--themeColor)
                            p
                                color #fff

                    &::after
                        border-bottom none
                .topbar-sharebtn
                    display flex
                    align-items center
                    cursor pointer
                    user-select none
                    >svg
                        width 24px
                        height 24px
                    >p
                        height 24px
                        margin-left 10px
                        color var(--themeColor)
                        font-size 14px
                .sharebox-container
                    position absolute
                    background #fff
                    max-width 400px
                    width 80%
                    height 178px
                    top 48px
                    right 0
                    z-index 1
            .page-waterfall
                overflow-x hidden
                overflow-y auto
                &::-webkit-scrollbar
                    width 8px
                    pointer-events none
                    background none
                &::-webkit-scrollbar-thumb
                    background #D2D3D6
                    border-radius 6px
                &::-webkit-scrollbar-track
                    background #fff
                &::-webkit-scrollbar-track-piece
                    background none
                &::-webkit-scrollbar-corner
                    background none
                &.pc-cn-bg
                    page_background()
                    &::-webkit-scrollbar-track
                        page_background()
    .dark-theme__workbench
        .worksArea-container
            .worksArea-topbar
                background-color #333333
                .menubox-menu
                    li
                        background #404040
                        color #fff
                        &.active
                            background #017FFF
                        &:hover
                            >p
                                color #fff !important
            .page-waterfall
                &::-webkit-scrollbar
                    width 8px
                    pointer-events none
                    background none
                &::-webkit-scrollbar-thumb
                    background #484849
                    border-radius 6px
                &::-webkit-scrollbar-track
                    background #1e1e20
</style>

<template>
    <div class="worksArea-container">
        <div
            class="worksArea-topbar"
            ref="worksAreaTopbar"
            :style="{
                top: !isfixed ? '0' : '60px',
                position: !isfixed ? 'relative' : 'fixed',
                'border-radius': !isfixed ? '5px' : '0',
                maxWidth: !isfixed ? '100%' : worksAreaTopbarWidth,
            }"
        >
            <WorksTopbar @toMenu="changeMenu" />
            <div class="topbar-sharebtn" @click.stop="showShareBox" v-if="false">
                <iconSymbol name="share" />
                <p>分享主页</p>
            </div>
            <div class="sharebox-container" v-show="showShare" v-if="false">
                <Sharebox @close="closeShareBox" />
            </div>
        </div>

        <PageWorks v-if="activeMenu == 0" :isfixed="isfixed" />
        <PageCollect v-if="activeMenu == 1" :isfixed="isfixed" />
        <PageLike v-if="activeMenu == 2" :isfixed="isfixed" />
        <PageFollow v-if="activeMenu == 3" />
    </div>
</template>

<script>
    import WorksTopbar from "./layout/topbar.vue";
    import Sharebox from "./layout/sharebox.vue";
    import PageWorks from "./page_works.vue";
    import PageCollect from "./page_collect.vue";
    import PageLike from "./page_like.vue";
    import PageFollow from "./page_follow.vue";
    export default {
        name: "WorksArea",
        data() {
            return {
                showShare: false,
                activeMenu: 0,
                worksAreaTopbarWidth: 0,
            };
        },
        components: {
            WorksTopbar,
            Sharebox,
            PageWorks,
            PageCollect,
            PageLike,
            PageFollow,
        },
        props: {
            isfixed: {
                type: Boolean,
                require: false,
                default: false,
            },
        },
        computed: {},
        methods: {
            changeMenu(e) {
                this.activeMenu = e;
            },
            showShareBox() {
                this.showShare = true;
            },
            closeShareBox() {
                this.showShare = false;
            },
            getWorksAreaTopbarWidth() {
                this.$nextTick(() => {
                    let worksAreaTopbar = this.$refs.worksAreaTopbar;
                    this.worksAreaTopbarWidth = worksAreaTopbar && worksAreaTopbar.offsetWidth;
                });
            },
        },
        mounted() {
            this.getWorksAreaTopbarWidth();
            window.addEventListener("resize", this.getWorksAreaTopbarWidth);
        },
        created() {},
        beforeDestroy() {
            this.$store.commit("toTplCenter", {
                name: "activedTab",
                data: 0,
            });
            window.removeEventListener("resize", this.getWorksAreaTopbarWidth);
        },
    };
</script>
